// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"190":"component/chapter","704":"component/book"}[chunkId] + "." + {"190":"fed09345","704":"442919cf"}[chunkId] + ".css";
};